module.exports = __webpack_public_path__ + "static/media/animated-envelope.a97bfdc5.gif";